import * as React from 'react';
/**
 *
 * Original name: file explorer
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A353
 *
 */
export const FileExplorerPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "m30.029 18-3.206-4.488A6.01 6.01 0 0 0 21.941 11H7v37a6.007 6.007 0 0 0 6 6h38a6.007 6.007 0 0 0 6-6V18H30.029ZM30 50v-6h5v6h-5Zm9 0V40H26v10h-5V35h22v15h-4Zm14-2a2 2 0 0 1-2 2h-4V31H17v19h-4a2 2 0 0 1-2-2V15h10.941a2 2 0 0 1 1.627.837L27.971 22H53v26Z", fill: "currentColor" })));
